/**
 * Hospital Introduction Page - JavaScript Module
 * @namespace JWHospital
 * @description OOP-based module for hospital introduction page functionality
 */
(function(window, document) {
    'use strict';

    // Namespace to avoid global conflicts
    const JWHospital = {
        config: {
            imageBasePath: '',
            selectors: {
                modal: '#myCustomModal',
                modalBodyContent: '#modal-body-content',
                modalTitle: '#modal-body-content-about-mb-title',
                modalContent: '#modal-body-content-about-mb-content',
				subtitleContent: '#modal-body-content-about-mb-subtitle',
				contentSubtitle: '#modal-body-content-about-mb-content-subtitle',
                closeButton: '.close-profile',
                openModalBtns: '.text-menu-mobi-title[data-info]',
                accordion: '.tab-about-Hospital >.accordion',
                panel: '.tab-about-Hospital > .hospital-accordion-panel',
                tabContent: '.tabcontent',
                tabLinks: '.tablinks',
                horizontalTabContent: '.horizontal-tab-content',
                horizontalTabLinks: '.horizontal-tablinks',
                horizontalTabContentTbyt: '.horizontal-tab-content-tbyt',
                horizontalTabLinksTbyt: '.horizontal-tablinks-tbyt'
            }
        },

        /**
         * Initialize the module with configuration
         * @param {Object} options - Configuration options
         */
        init: function(options) {
            if (options && options.imageBasePath) {
                this.config.imageBasePath = options.imageBasePath;
            }

            // Initialize all modules
            const hash = this.URLHashHandler.init();
            this.TabNavigation.init(hash);
            this.HorizontalTabs.init();
            this.HorizontalTabsTbyt.init();
            this.AccordionMenu.init();
            this.DoctorProfileModal.init();
        },

        /**
         * Doctor Profile Modal Module
         */
        DoctorProfileModal: {
            elements: {},
            profileData: {},

            init: function() {
                this.cacheElements();
                if (!this.elements.modal) return;

                this.setupProfileData();
                this.bindEvents();
                this.checkMobile();
            },

            cacheElements: function() {
                const selectors = JWHospital.config.selectors;
                this.elements = {
                    modal: document.querySelector(selectors.modal),
                    bodyContent: document.querySelector(selectors.modalBodyContent),
                    titleContent: document.querySelector(selectors.modalTitle),
                    contentContent: document.querySelector(selectors.modalContent),
					subtitleContent: document.querySelector(selectors.subtitleContent),
					contentSubtitle: document.querySelector(selectors.contentSubtitle),
                    closeButton: document.querySelector(selectors.closeButton),
                    openButtons: document.querySelectorAll(selectors.openModalBtns)
                };
            },

            setupProfileData: function() {
                const basePath = JWHospital.config.imageBasePath;

                this.profileData = {
                    'profile-bstudung': {
                        imageMobile: basePath + 'profile-bs-tu-dung-v2-mb.webp',
                        imageDesktop: basePath + 'profile-bs-tu-dung-v2-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
                            <p>- Thư ký quốc gia Hội Tạo hình mũi Châu Á - RSA.</p>
							<p>- Thành viên Hội Tạo hình Thẩm mỹ Quốc tế ISAPS.</p>
							<p>- Thành viên Hội Tạo hình Thẩm mỹ Việt Nam VSAPS.</p>
							<p>- Bác sĩ Việt Nam đầu tiên tham gia điều hành phiên Chủ tịch PRS Hàn Quốc.</p>
							<p>- Bác sĩ Việt Nam đầu tiên tham gia biên soạn sách Phẫu thuật Tạo hình đầu mặt Facial Aesthetic Surgery tại Hoa Kỳ.</p>`,
						subtitle: 'GIẢI THƯỞNG',
						contentSubtitle: `
                            <p>- Huân chương Lao động hạng Ba.</p>
							<p>- Á quân Hiệp hội Nội khoa Hoa Kỳ ACOI.</p>
							<p>- Cúp vàng tại Thành tựu Y khoa Việt Nam.</p>
							<p>- Bằng khen vinh danh của Thủ tướng Chính phủ.</p>
							<p>- Hai bằng khen vinh danh của Bộ trưởng Bộ Y tế.</p>
							<p>- Bằng khen của Bộ trưởng Bộ Giáo dục và Đào tạo.</p>
							<p>- Bằng khen từ Hội Khuyến học, Học bổng Vừ A Dính.</p>
							<p>- Bộ Y tế tặng Kỷ niệm chương Vì sức khỏe Nhân dân.</p>
							<p>- Hai bằng khen từ Chủ tịch Ủy ban Nhân dân TP.HCM.</p>
							<p>- Bằng khen của Ủy ban Mặt trận Tổ quốc Việt Nam TP. Đà Nẵng.</p>
							<p>- Giải thưởng Bác sĩ tiêu biểu trong chương trình “Người thầy thuốc trong tôi”.</p>
                        `
                    },
					'profile-bslethienhieu': {
                        imageMobile: basePath + 'profile-bs-le-thien-hieu-v2-mb.webp',
                        imageDesktop: basePath + 'profile-bs-le-thien-hieu-v2-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
     						<p>- Bác sĩ Đa khoa - Đại học Y Dược TP.HCM.</p>
							<p>- Thạc sĩ Y học - Đại học Y Dược TP.HCM.</p>
							<p>- Định hướng chuyên khoa Phẫu thuật Tạo hình - Đại học Y Hà Nội.</p>
							<p>- Thành viên Hiệp hội tạo hình mũi Châu Á.</p>
							<p>- Kỷ niệm chương “Vì sức khỏe nhân dân” của Bộ Y tế.</p>
							<p>- Chứng chỉ: Kiểm soát nhiễm khuẩn.</p>
							<p>- Chứng chỉ đào tạo liên tục: Kiểm soát nhiễm khuẩn.</p>
							<p>- Chứng chỉ đào tạo: Cập nhật kiến thức tạo hình thẩm mỹ.</p>
							<p>- Chứng chỉ đào tạo: Cập nhật kiến thức tạo hình thẩm mỹ.</p>
							<p>- Chứng chỉ: Phẫu thuật tạo hình thẩm mỹ mũi cấu trúc nâng cao 2023.</p>
							<p>- Chứng chỉ đào tạo: Phẫu thuật tạo hình thẩm mỹ mũi cấu trúc nâng cao.</p>
							<p>- Chứng chỉ đào tạo: Xu hướng nâng ngực với kỹ thuật Motiva Hybrid.</p>
							<p>- Chứng nhận hoàn thành khóa học: Phẫu thuật tạo hình thẩm mỹ vùng đầu mặt cổ.</p>
							<p>- Chứng nhận hoàn thành khóa học: Phẫu thuật tạo hình thẩm mỹ tái cấu trúc nâng cao.</p>
							<p>- Chứng nhận tham dự hội nghị: Motiva Implants - Xu hướng mới trong nâng ngực thẩm mỹ.</p>
							<p>- Chứng nhận tham dự hội thảo khoa học thẩm mỹ: Vì sự hoàn hảo của nét đẹp Phương </p>Đông.
							<p>- Chứng nhận đã tham dự chương trình: Cập nhật kiến thức về phẫu thuật tạo hình thẩm mỹ và tai mũi họng.</p>
                        `
                    },
                    'profile-bsmankoonsuh': {
                        imageMobile: basePath + 'profile-bs-man-koon-suh-mb.webp',
                        imageDesktop: basePath + 'profile-bs-man-koon-suh-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
							<p>- Giám đốc Hệ thống JW toàn cầu</p>
							<p>- Giám đốc nghiên cứu viện phục hồi Đại học Y Yonsei</p>
							<p>- Giám đốc học thuật Hội nghiên cứu phẫu thuật mũi Hiệp hội phẫu thuật tạo hình Hàn Quốc</p>
							<p>- Giảng viên trường Đại học Y Yeonsei</p>
							<p>- Ủy viên thẩm định báo Hiệp hội phẫu thuật thẩm mỹ Hàn Quốc.</p>
							<p>- Hội viên Hiệp hội chỉnh hình Hàn Quốc</p>
							<p>- Hội viên chính thức Hiệp hội phẫu thuật tạo hình Quốc Tế.</p>
							<p>- Thành viên Viện nghiên cứu phục chế mô cơ con người thuộc Trường Đại học Y Yonsei. </p>
							<p>- Ấn phẩm đã xuất bản:</p>
							<p>Sách "Phẫu thuật mũi Châu Á (Asisan rhinoplasty)</p>
							<p>Nghiên cứu và phát triển cho ngành nâng mũi hiện đại của Châu Á</p>
                        `,
                    },
                    'profile-bschulhwanseul': {
                        imageMobile: basePath + 'profile-bs-schul-hwan-seul-mb.webp',
                        imageDesktop: basePath + 'profile-bs-schul-hwan-seul-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
							<p>- Chủ tịch Hội nghiên cứu phẫu thuật ngực </p>
							<p>- Hiệp hội Phẫu thuật tạo hình Hàn Quốc</p>
							<p>- Giáo sư phẫu thuật tạo hình tại Đại học Severance Yeong Dong </p>
							<p>- Ủy viên khảo thí Hiệp hội phẫu thuật tạo hình Hàn Quốc</p>
							<p>- Chuyên gia phẫu thuật tạo hình tại Bệnh viện Severance </p>
							<p>- Chuyên gia thẩm mỹ tạo hình tại JW Hàn Quốc</p>
							<p>- Hội viên chính thức Hiệp hội phẫu thuật tạo hình Quốc tế</p>
							<p>- Hội viên chính thức Hiệp hội phẫu thuật thẩm mỹ Hàn Quốc </p>
							<p>- Hội viên chính thức Hiệp hội phẫu thuật tay Hàn Quốc</p>
							<p>- Hội viên chính thức Hiệp hội tạo hình phẫu thuật xương mặt Hàn Quốc</p>
						`,
                    },
                    'profile-bshonglimchoi': {
                        imageMobile: basePath + 'profile-bs-hong-lim-choi-mb.webp',
                        imageDesktop: basePath + 'profile-bs-hong-lim-choi-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
							<p>- Tốt nghiệp Đại học y Yonsei Hàn Quốc</p>
							<p>- Nhận học vị Tiến sĩ Y học tại Đại học y Yonsei Hàn Quốc</p>
							<p>- Nhận bằng đào tạo Phẫu thuật Thẩm mỹ tại Đại học New York</p>
							<p>- Giám đốc Hiệp hội thẩm mỹ Hàn Quốc</p>
							<p>- Giám đốc học thuật Câu lạc bộ nghiên cứu phẫu thuật mắt của Hiệp hội Thẩm mỹ mắt Hàn Quốc</p>
							<p>- Thành viên chính thức của Hiệp hội Thẩm mỹ mắt Hàn Quốc</p>
							<p>- Chuyên gia phẫu thuật thẩm mỹ mắt tại Bệnh viện Thẩm mỹ JW Hàn Quốc</p>
							<p>- Chuyên gia chỉnh hình, tái phẫu thuật mắt hỏng - Bệnh viện Thẩm mỹ JW Hàn Quốc</p>
							<p>- Hội viên chính thức Hiệp hội chỉnh hình Hàn Quốc</p>
							<p>- Hội viên chính thức Hiệp hội sắc đẹp Nhật Bản</p>
							<p>- Hội viên chính thức Hiệp hội chỉnh hình Quốc tế</p>
							<p>- Cùng TS.BS Nguyễn Phan Tú Dung đồng sáng lập Trung tâm Tái phẫu thuật mắt đầu tiên tại Việt Nam</p>
                        `,
                    },
					'profile-bsungmachyminh': {
                        imageMobile: basePath + 'profile-bs-ung-mac-hy-minh-mb.webp',
                        imageDesktop: basePath + 'profile-bs-ung-mac-hy-minh-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
     						<p>- Bác sĩ Y đa khoa - Đại học Y Dược TP.HCM.</p>
							<p>- Bác sĩ Chuyên khoa 1 chuyên ngành Gây mê hồi sức - Đại học Y Dược TP.HCM.</p>
							<p>- Chứng nhận đào tạo liên tục chuyên ngành Gây mê hồi sức - Đại học Y Dược TP.HCM.</p>
							<p>- Chứng chỉ: Kiểm soát nhiễm khuẩn.</p>
							<p>- Chứng chỉ: Hồi sức tim phổi nâng cao.</p>
							<p>- Chứng nhận đào tạo: An toàn người bệnh trong Phẫu thuật Thẩm mỹ.</p>
							<p>- Chứng chỉ: Góc nhìn đa chiều nhằm nâng cao tính an toàn trong gây mê hồi sức.</p>
							<p>- Chứng chỉ: An toàn trong thực hành Gây mê hồi sức và Kiểm soát nhiễm trùng hậu phẫu.</p>
							<p>- Chứng nhận tham dự: Hội nghị Khoa học thường niên 2019 - 2025 “Cập nhật kiến thức chuyên ngành gây mê hồi sức”.</p>
                        `
                    },
					'profile-bsdinhthithuyen': {
                        imageMobile: basePath + 'profile-bs-dinh-thi-thu-yen-mb.webp',
                        imageDesktop: basePath + 'profile-bs-dinh-thi-thu-yen-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
     						<p>- Chứng chỉ: Hồi sức tim phổi nâng cao.</p>
							<p>- Chứng chỉ: Kiểm soát đường khó thở.</p>
							<p>- Chứng chỉ: Cập nhật gây mê hồi sức trẻ em năm 2022.</p>
							<p>- Chứng nhận tham dự: Hội nghị khoa học thường niên 2025 - Cập nhật kiến thức chuyên ngành gây mê hồi sức.</p>
							<p>- Chứng chỉ: Kiểm soát nhiễm khuẩn cơ bản dành cho nhân viên Y tế trong các cơ sở khám bệnh, chữa bệnh có giường bệnh nội trú.</p>
                        `
                    },
					'profile-bsnguyenthehai': {
                        imageMobile: basePath + 'profile-bs-nguyen-the-hai-mb.webp',
                        imageDesktop: basePath + 'profile-bs-nguyen-the-hai-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
     						<p>- Bác sĩ Tạo hình Thẩm mỹ - Đại học Quốc gia TP.HCM.</p>
							<p>- Bác sĩ Đa khoa - Đại học Y khoa Phạm Ngọc Thạch.</p>
							<p>- Định hướng Phẫu thuật Tạo hình Thẩm mỹ - Đại học Y Dược TP.HCM.</p>
							<p>- Bác sĩ Chuyên khoa 1 chuyên ngành Phẫu thuật Tạo hình, Tái tạo và Thẩm mỹ.</p>
							<p>- Chứng chỉ: Dinh dưỡng tiết chế.</p>
							<p>- Chứng chỉ: Kiểm soát nhiễm khuẩn.</p>
							<p>- Chứng chỉ: Điều trị bệnh lý thiếu hụt chất dinh dưỡng.</p>
							<p>- Chứng chỉ: Hồi sinh tim phổi cơ bản dựa trên mô phỏng lâm sàng.</p>
							<p>- Chứng chỉ: Dinh dưỡng kiểm soát béo phì và bệnh không lây nhiễm.</p>
							<p>- Chứng chỉ: Phẫu thuật Tạo hình Thẩm mỹ vùng Ngực - Mũi và Thẩm mỹ Nội khoa.</p>
							<p>- Chứng chỉ: An toàn thực hành thực hành Gây mê hồi sức và Kiểm soát nhiễm trùng hậu phẫu.</p>
							<p>- Chứng chỉ: Ứng dụng Hyaluronic công nghệ kép Nahyco Hybrid trong trẻ hóa và tạo đường nét cơ thể.</p>
							<p>- Chứng nhận tham dự Hội nghị Khoa học Quốc tế thường niên - Phẫu thuật Tạo hình Thẩm mỹ khu vực Sông Mekong.</p>
                        `
                    },
                    'profile-bsnguyenthihongloan': {
                        imageMobile: basePath + 'profile-bs-nguyen-thi-hong-loan-v2-mb.webp',
                        imageDesktop: basePath + 'profile-bs-nguyen-thi-hong-loan-v2-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
                            <p>- Hội viên Liên Chi hội Da liễu TP.HCM.</p>
							<p>- Hội viên Chi hội Thẩm mỹ Nội khoa Việt Nam.</p>
							<p>- Chứng chỉ: Kiểm soát nhiễm khuẩn.</p>
							<p>- Chứng chỉ: Thủ thuật treo chỉ trong da.</p>
							<p>- Chứng chỉ: Thủ thuật cơ bản và tiểu phẫu da.</p>
							<p>- Chứng chỉ: Cập nhật điều trị Da liễu, Thẩm mỹ da.</p>
							<p>- Chứng chỉ: Tiếp cận đa chiều trong điều trị rụng tóc.</p>
							<p>- Chứng chỉ: Kỹ thuật tiêm chất làm đầy trong Thẩm mỹ.</p>
							<p>- Chứng chỉ: Ứng dụng Laser và ánh sáng trong Da liễu.</p>
							<p>- Chứng chỉ: Kỹ thuật tiêm Botulinum Toxin trong Thẩm mỹ.</p>
							<p>- Chứng nhận tham dự: Hội nghị Da liễu Thẩm mỹ Miền Nam 2025.</p>
							<p>- Chứng chỉ: Phòng ngừa và phục hồi tổn thương da sau Thẩm mỹ và Điều trị da.</p>
							<p>- Tham dự: Hội thảo Khoa học “Chiến lược kiểm soát toàn diện mụn trứng cá”.</p>
							<p>- Chứng chỉ: Kết hợp đa dạng chất làm đầy và căng chỉ trong tạo hình khuôn mặt.</p>
							<p>- Chứng chỉ: Hướng tiếp cận và điều trị toàn diện trong Da liễu và Thẩm mỹ Nội khoa.</p>
							<p>- Chứng chỉ: Thực hành lâm sàng gắn kết nghiên cứu Khoa học chuyên ngành Da liễu.</p>
                        `
                    },
                    'profile-bsdaohaiyen': {
                        imageMobile: basePath + 'profile-bs-dao-hai-yen-v2-mb.webp',
                        imageDesktop: basePath + 'profile-bs-dao-hai-yen-v2-pc.webp',
                        title: 'CÔNG TÁC CHUYÊN MÔN',
                        content: `
                            <p>- Bác sĩ Đa khoa - Đại học Y Dược TP.HCM.</p>
							<p>- Chuyên khoa I chuyên ngành Da liễu - Đại học Y khoa Phạm Ngọc Thạch.</p>
							<p>- Chứng chỉ: Thủ thuật cơ bản và tiểu phẫu da.</p>
							<p>- Chứng chỉ: Liệu pháp Exosome trong điều trị Da liễu, Thẩm mỹ da.</p>
							<p>- Chứng nhận tham dự: Hội nghị Khoa học Da liễu Miền Nam 2024.</p>
							<p>- Tham gia các khóa đào tạo Da liễu, Thẩm mỹ Nội khoa tại Hàn Quốc, Singapore, Thái Lan.</p>
							<p>- Chứng chỉ: Sử dụng kỹ thuật cơ bản Laser trong xử trí tổn thương mạch máu, sắc tố da và sẹo.</p>
							<p>- Chứng chỉ: Cập nhật chứng nhận đào tạo Y khoa Liên tục về các điều trị mới và công nghệ mới trong Da liễu, Thẩm mỹ Da, Thẩm mỹ Nội khoa.</p>
							<p>- Chứng nhận tham dự: Hội nghị Khoa học Da liễu Miền Nam 2025 - Đổi mới trong Da liễu: Kết nối & Phát triển.</p>
                        `
                    },
					'profile-bsletrongtam': {
						imageMobile: basePath + 'profile-bs-le-trong-tam-mb.webp',
						imageDesktop: basePath + 'profile-bs-le-trong-tam-pc.webp',
						title: 'CÔNG TÁC CHUYÊN MÔN',
						content: `
							<p>- Tốt nghiệp đại học Y Dược TP.HCM</p>
							<p>- Hơn 10 năm công tác tại các Bệnh viện Răng Hàm Mặt</p>
							<p>- Chứng chỉ Implant tại Bệnh viện Răng Hàm Mặt Trung ương 2021</p>
							<p>- Chứng chỉ Implant toàn hàm All-on X Sagodent 2022</p>
							<p>- Chứng chỉ nâng xoang Đại học Văn Lang 2023, Dentium 2023</p>
							<p>- Chứng chỉ phục hình trên Implant THL Academy 2021</p>
							<p>- Chứng chỉ phẫu thuật răng khôn THL Academy 2023</p>
							<p>- Chứng chỉ Implant Nâng cao Osstem 2023</p>
							<p>- Chứng chỉ ghép mô mềm quanh Implant 2022</p>
							<p>- Chứng chỉ Implant toàn hàm xâm lấn tối thiểu 2023, ghép xương Carotta 2024, Implant chân bướm 2024 của BSNT Bùi Thanh Tùng</p>
							<p>- Chứng chỉ Digital Implant Việt Đăng 2024</p>
							<p>- Tham gia các hội thảo về Implant trong và ngoài nước</p>
						`
					},
                    'default': {
                        imageMobile: basePath + 'default-mobile.webp',
                        imageDesktop: basePath + 'default.webp',
                        title: 'Thông tin bác sĩ',
                        content: 'Chuyên môn : lỗi kết nối'
                    }
                };
            },

            bindEvents: function() {
                const self = this;

                // Open modal buttons
                this.elements.openButtons.forEach(function(btn) {
                    btn.addEventListener('click', function() {
                        const info = this.getAttribute('data-info');

                        if (!info || !self.profileData[info]) {
                            return;
                        }

                        self.openModal(info);
                    });
                });

                // Close button
                if (this.elements.closeButton) {
                    this.elements.closeButton.addEventListener('click', function() {
                        self.closeModal();
                    });
                }

                // Click outside to close
                window.addEventListener('click', function(event) {
                    if (event.target === self.elements.modal) {
                        self.closeModal();
                    }
                });

                // Resize handler
                window.addEventListener('resize', function() {
                    self.checkMobile();
                });
            },

            checkMobile: function() {
                const isMobile = window.matchMedia('(max-width: 490px)').matches;
                if (this.elements.modal) {
                    this.elements.modal.classList.toggle('mobile', isMobile);
                }
            },

            isMobile: function() {
                return window.matchMedia('(max-width: 490px)').matches;
            },

            openModal: function(profileId) {
                const profile = this.profileData[profileId];
                if (!profile) return;

                const imageSrc = this.isMobile() ? profile.imageMobile : profile.imageDesktop;
				document.body.style.overflow = 'hidden'; // Disable background scrolling when modal is open

                if (this.elements.bodyContent && imageSrc) {
                    this.elements.bodyContent.innerHTML = '<img src="' + imageSrc + '" alt="Profile Image">';
                }
                if (this.elements.titleContent && profile.title) {
                    this.elements.titleContent.innerHTML = '<h2>' + profile.title + '</h2>';
                }
                if (this.elements.contentContent && profile.content) {
                    this.elements.contentContent.innerHTML = profile.content;
                }
				if (this.elements.subtitleContent && profile.subtitle) {
					this.elements.subtitleContent.innerHTML = '<h2>' + profile.subtitle + '</h2>';
				}
				if (this.elements.contentSubtitle && profile.contentSubtitle) {
					this.elements.contentSubtitle.innerHTML = profile.contentSubtitle;
				}
                if (this.elements.modal) {
                    this.elements.modal.style.display = 'block';
                }
            },

            closeModal: function() {
				document.body.style.overflow = 'auto'; // Re-enable background scrolling when modal is closed
                if (this.elements.modal) {
                    this.elements.modal.style.display = 'none';
                }
            }
        },

        /**
         * Accordion Menu Module
         */
        AccordionMenu: {
            elements: [],

            init: function() {
                this.elements = document.querySelectorAll(JWHospital.config.selectors.accordion);
                this.bindEvents();
            },

            bindEvents: function() {
                const self = this;
                this.elements.forEach(function(accordion) {
                    accordion.addEventListener('click', function() {
                        self.toggle(this);
                    });
                });
            },

            toggle: function(element) {
                element.classList.toggle('active');
                const panel = element.nextElementSibling;
                if (panel) {
                    panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
                }
            },

            closeAll: function() {
                const panels = document.querySelectorAll(JWHospital.config.selectors.panel);
                panels.forEach(function(panel) {
                    panel.style.display = 'none';
                });
            }
        },

        /**
         * Main Tab Navigation Module
         */
        TabNavigation: {
            init: function (hash) {
                if (hash) {
                    this.openTab(null, hash);
                    return;
                }

                const defaultTab = document.getElementById('defaultOpen');
                if (defaultTab) {
                    const defaultHash = defaultTab.getAttribute('data-hash');
                    this.openTab({ currentTarget: defaultTab }, defaultHash);
                }
            },

            getTabLabel: function (tabName) {
                const matchedTab = document.querySelector(`.tablinks[data-hash="${tabName}"]`);
                if (!matchedTab) return 'Giới thiệu';

                const labelNode =
                    matchedTab.querySelector('.text-menu-mobi-title') ||
                    matchedTab.querySelector('span') ||
                    matchedTab.querySelector('p') ||
                    matchedTab;

                return labelNode.textContent.trim();
            },

            updateAccordionDisplay: function (label) {
                const mobileTitle = document.querySelector('.tab-about-Hospital .accordion-display p');
                if (mobileTitle) {
                    mobileTitle.textContent = label;
                }
            },

            setActiveTabLinks: function (tabName) {
                const selectors = JWHospital.config.selectors;
                const tabLinks = document.querySelectorAll(selectors.tabLinks);

                tabLinks.forEach(function (link) {
                    link.classList.remove('active');
                });

                const matchedLinks = document.querySelectorAll(`.tablinks[data-hash="${tabName}"]`);
                matchedLinks.forEach(function (link) {
                    link.classList.add('active');
                });
            },

            openTab: function (evt, tabName) {
                const selectors = JWHospital.config.selectors;

                const tabContents = document.querySelectorAll(selectors.tabContent);
                tabContents.forEach(function (content) {
                    content.style.display = 'none';
                });

                const targetTab = document.getElementById(tabName);
                if (targetTab) {
                    targetTab.style.display = 'block';
                }

                this.setActiveTabLinks(tabName);
                this.updateAccordionDisplay(this.getTabLabel(tabName));

                if (window.innerWidth < 768) {
                    JWHospital.AccordionMenu.closeAll();

                    const accordion = document.querySelector(JWHospital.config.selectors.accordion);
                    if (accordion) {
                        accordion.classList.remove('active');
                    }
                }

                location.hash = tabName;

                setTimeout(function () {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }, 250);
            }
        },

        /**
         * Horizontal Tabs Module (Doctor tabs)
         */
        HorizontalTabs: {
            init: function() {
                const firstTab = document.querySelector(JWHospital.config.selectors.horizontalTabLinks);
                if (firstTab) {
                    firstTab.click();
                }
            },

            openTab: function(evt, tabName) {
                const selectors = JWHospital.config.selectors;

                // Hide all horizontal tab content
                const tabContents = document.querySelectorAll(selectors.horizontalTabContent);
                tabContents.forEach(function(content) {
                    content.style.display = 'none';
                });

                // Remove active class from all horizontal tab links
                const tabLinks = document.querySelectorAll(selectors.horizontalTabLinks);
                tabLinks.forEach(function(link) {
                    link.classList.remove('activeDoctor');
                });

                // Show current tab and add active class
                const targetTab = document.getElementById(tabName);
                if (targetTab) {
                    targetTab.style.display = 'block';
                }
                if (evt && evt.currentTarget) {
                    evt.currentTarget.classList.add('activeDoctor');
                }
            }
        },

        /**
         * Horizontal Tabs TBYT Module (Medical Equipment tabs)
         */
        HorizontalTabsTbyt: {
            init: function() {
                const firstTab = document.querySelector(JWHospital.config.selectors.horizontalTabLinksTbyt);
                if (firstTab) {
                    firstTab.click();
                }
            },

            openTab: function(evt, tabName) {
                const selectors = JWHospital.config.selectors;

                // Hide all horizontal tab content
                const tabContents = document.querySelectorAll(selectors.horizontalTabContentTbyt);
                tabContents.forEach(function(content) {
                    content.style.display = 'none';
                });

                // Remove active class from all horizontal tab links
                const tabLinks = document.querySelectorAll(selectors.horizontalTabLinksTbyt);
                tabLinks.forEach(function(link) {
                    link.classList.remove('activeDoctor');
                });

                // Show current tab and add active class
                const targetTab = document.getElementById(tabName);
                if (targetTab) {
                    targetTab.style.display = 'block';
                }
                if (evt && evt.currentTarget) {
                    evt.currentTarget.classList.add('activeDoctor');
                }
            }
        },

        /**
         * URL Hash Handler Module
         */
        URLHashHandler: {
            init: function() {
                const hash = window.location.hash.substring(1);
				if (hash) {
					return hash;
				}
				return null;
            }
        }
    };

    // Expose global functions for inline onclick handlers (backward compatibility)
    window.openCity = function(evt, cityName) {
        JWHospital.TabNavigation.openTab(evt, cityName);
    };

    window.openHorizontalTab = function(evt, tabName) {
        JWHospital.HorizontalTabs.openTab(evt, tabName);
    };

    window.openHorizontalTabTbyt = function(evt, tabName) {
        JWHospital.HorizontalTabsTbyt.openTab(evt, tabName);
    };

    window.closeAllPanels = function() {
        JWHospital.AccordionMenu.closeAll();
    };

    // Expose namespace globally
    window.JWHospital = JWHospital;

})(window, document);

document.addEventListener('DOMContentLoaded', function() {
	const templateUrl = window.location.origin + '/wp-content/themes/jw-zw';
	// Initialize JWHospital module with configuration
	JWHospital.init({
		imageBasePath: templateUrl + '/assets/images/img-gioi-thieu-benh-vien/'
	});
});
